import { render, staticRenderFns } from "./RegionalHighlights.vue?vue&type=template&id=68fbf3d2&scoped=true"
import script from "./RegionalHighlights.vue?vue&type=script&lang=js"
export * from "./RegionalHighlights.vue?vue&type=script&lang=js"
import style0 from "./RegionalHighlights.vue?vue&type=style&index=0&id=68fbf3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fbf3d2",
  null
  
)

export default component.exports